<template lang="pug">
div(:class="{ 'mb-15': isMissingMemo || hasPaymentError || isRestricted || (!isEnabled && !isEnabledOnlyAutomatic) || isFresh || (isNotActivated && coin === 'XRP') }")
  .result-no-memo.notification.is-danger.has-text-left.fs-12(v-if="isMissingMemo")
    .fs-12
      b You are mining to an exchange or third party wallet address with no Payment ID, Memo or Tag!
    .fs-13.mt-10
      b
        u Stop mining immediately as any mining reward associated to this address is unrecoverable and non transferable
    .fs-12.mt-10
      span You must add your Payment ID, Memo or Tag right after the address in the user param of your miner (followed by a : symbol), like this:
    .fs-13.mt-10.wb-ba
      b.opacity-05 {{ coin }}
      b.fredoka-style :
      b.opacity-05 {{ address }}
      b.fredoka-style :
      b YourPaymentID
      b.fredoka-style .
      b.opacity-05 YourWorkerName
    .mt-10
      span Otherwise we will be unable to pay your coins!

  .result-error-address.notification.is-danger.has-text-left(v-if="hasPaymentError")
    p
      b There seems to be an issue with your address!
    .mt-10
      p
        b We tried to process your payment many times with no success.
    .mt-10
      p
        span This usually happens when there is a typo or incorrect capitalization in your address (most networks are case-sensitive). To resolve this, simply reconnect your miner using the correct capitalization, then try again after a few minutes.
    .mt-10
      p 
        span If you are still having issues or your address has a wrong, extra or missing letter, kindly contact us for help

  .result-restricted.notification.is-danger(v-if="isRestricted")
    p 
      span Your address has been restricted from joining our platform due to suspected botnet, web mining, or similar activity. If you are operating a legitimate service or managing more than 100 active connections, please connect through port 4445 using a proxy (
      a(href="https://github.com/MoneroOcean/xmr-node-proxy", target="=_blank") 
        span xmr-node-proxy
        span &nbsp;
        i.fa.fa-external-link.fs-12
      span  or 
      a(href="https://github.com/xmrig/xmrig-proxy", target="_blank") 
        span xmrig-proxy
        span &nbsp;
        i.fa.fa-external-link.fs-12
      span ).

  .result-maintenance.notification.is-info.is-info-dark(v-if="!isDelisted && !isEnabled && !isEnabledOnlyAutomatic")
    p 
      div
        span Payments for the {{ chain.name }} network are currently under maintenance

        span(v-if="maintenanceMessage")
          span : 
          span(v-html="maintenanceMessage")
        span(v-else) . 
        u Mining is not affected!

      .multi-chain-support(v-if="chains.length > 1")
        span You may try another network, we also support payouts through the 
        span.multi-chains 
          span(v-for="item, index in chainsWithoutCurrent") 
            span(v-if="index > 0 && index === chainsWithoutCurrent.length - 1")  and 
            span {{ item.name }} ({{ item.token_standard }})
            span(v-if="index < chainsWithoutCurrent.length - 2") , 
        span  chains.

  .result-maintenance.notification.is-danger.is-danger-dark(v-if="isDelisted")
    p 
      div
        b This coin or token has been delisted and no further rewards will be credited.
        br
        span For more information kindly check the News section or our 
        a(href="https://x.com/un_mineable", target="_blank")  official X feed.
        br
        br
        span Be sure to point your workers to another coin!

  .result-new-address.notification.is-info.is-info-dark.has-text-left(v-if="isFresh")
    .fs-16
      b Welcome to your stats!
    .mt-10
      p.mb-10 
        span To start use a compatible mining software and connect to any of our supported pools! You can find some examples in the  
        router-link(:to="'/'")  Start 
        span  option of the website.
      p.mb-10
        span You could also share your Referral Code and  
        router-link(to="/referrals")  start earning referral rewards right away!  
        span  Even if you are not mining on your own.
      p.mb-10
        span If you have any issue or suggestion please take a look at our 
        a(href='https://unmineable.com/support') Support Center.
      p.mb-10
        span Happy mining!

  .result-not-activated.notification.is-warning(v-if="isNotActivated && coin === 'XRP'")
    p 
      span Your XRP address is 
      b not activated. 
      span Your first payout will  
      a(href='https://xrpl.org/reserves.html', target='_blank') 
        span activate your address 
        i.fa.fa-external-link-square

</template>

<script>
export default {
  name: 'c_stats_notification',
  props: ['chain', 'address', 'chains', 'isMissingMemo', 'hasPaymentError', 'isRestricted', 'isEnabled', 'isEnabledOnlyAutomatic', 'isFresh', 'isNotActivated', 'hasNoWorkers', 'addressFromDB', 'maintenanceMessage', 'isDelisted'],
  data() {
    return {
    }
  },
  computed: {
    chainsWithoutCurrent () {
      let vm = this
      let withoutCurrent = [];
      for (let item of vm.chains) {
        if (item.network !== vm.chain.network) withoutCurrent.push(item);
      }
      return withoutCurrent
    },
    coin() {
      return this.$store.getters.coin
    }
  }
}
</script>

<style lang="stylus" scoped>
.fredoka-style
  font-family: 'Fredoka one';
  margin: 0px 3px
</style>



// WEBPACK FOOTER //
// c_stats_notification.vue?da06b120